import React, { useEffect, useState } from 'react'
import TextInput from '../form/TextInput'
import Button1 from '../form/Button1'

export default function PinForm({callback,close}) {
    const [data,setData] = useState({pin: ''})

    useEffect(() => {
        setData({pin: ''})
    },[close])

    async function handleSubmit(ev) {
        ev?.preventDefault();
        
        callback && callback(data?.pin)
    }
    
  return (
    <form onSubmit={handleSubmit} className='flex flex-col gap-4 p-8 '>
        <h5>Enter your pin</h5>
        <TextInput label='PIN' value={data?.pin} onChange={(ev) => setData({...data,pin: ev.target.value})} />
        <div className='flex gap-2 items-center'>
            {close ? 
                <div>
                    <Button1 variant='outlined' onClick={() => close()}>Cancel</Button1>
                </div>
            :null}
            <Button1 type='submit'>Confirm</Button1>
        </div>
    </form>
  )
}
